import store from '@/store/index'; // Asegúrate de la ruta correcta

const createModal = () => {
    const modalDiv = document.createElement('div');
    modalDiv.id = 'modal-alert';
    modalDiv.style.position = 'fixed';
    modalDiv.style.top = '0';
    modalDiv.style.left = '0';
    modalDiv.style.width = '100%';
    modalDiv.style.height = '100%';
    modalDiv.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
    modalDiv.style.display = 'flex';
    modalDiv.style.flexDirection = 'column'; // Para apilar los divs verticalmente
    modalDiv.style.justifyContent = 'center';
    modalDiv.style.alignItems = 'center';
    modalDiv.style.zIndex = '1000';

     // Div main
     const contentMain = document.createElement('div');
     contentMain.style.backgroundColor = 'white';
     contentMain.style.padding = '20px';
     contentMain.style.borderRadius = '5px';
     contentMain.style.textAlign = 'center';

    // Primer div de contenido
    const contentDiv = document.createElement('div');
    contentDiv.style.backgroundColor = 'white';
    contentDiv.style.padding = '20px';
    contentDiv.style.borderRadius = '5px';
    contentDiv.style.textAlign = 'center';
    contentDiv.textContent = 'Servicio suspendido por incumplimiento de pago.';

    // Segundo div de contenido
    const contentSecondDiv = document.createElement('div');
    contentSecondDiv.style.backgroundColor = 'white';
    contentSecondDiv.style.padding = '20px';
    contentSecondDiv.style.borderRadius = '5px';
    contentSecondDiv.style.textAlign = 'center';
    contentSecondDiv.textContent = 'Por favor, comunicar con su proveedor.';

    // Tercer div de contenido
    const contentthreeDiv = document.createElement('div');
    contentthreeDiv.style.backgroundColor = 'white';
    contentthreeDiv.style.padding = '20px';
    contentthreeDiv.style.borderRadius = '5px';
    contentthreeDiv.style.textAlign = 'center';
    contentthreeDiv.textContent = 'Gracias.';

    contentMain.appendChild(contentDiv);
    contentMain.appendChild(contentSecondDiv);
    contentMain.appendChild(contentthreeDiv);

    // Añade los divs al modal
    modalDiv.appendChild(contentMain);

    return modalDiv;
};

export const modalAlert = (intervalInMinutes = 30) => {

  // Verifica el estado del servicio al iniciar la aplicación
  store.dispatch('service-settings/fetchServiceStatus');
  

  // Función para verificar y renderizar el modal si es necesario
  const checkAndRenderModal = () => {
    const serviceActive = store.state['service-settings'].serviceActive
    const existingModal = document.querySelector('#modal-alert');
    if (!serviceActive) {
        // Si el servicio no está activo y el modal no está en el DOM, crea e inserta el modal
        if (!existingModal) {
            const modalElement = createModal();
            document.body.appendChild(modalElement);
        }
    } else {
        // Si el servicio está activo, elimina el modal si existe
        if (existingModal) {
            document.body.removeChild(existingModal);
        }
    }
  };

  // Función que programa la primera ejecución a la próxima marca de intervalInMinutes
  const scheduleNextExecution = () => {
    const now = new Date();
    
    // Calcula los minutos restantes hasta la próxima marca de intervalInMinutes
    const minutes = now.getMinutes();
    const seconds = now.getSeconds();
    const milliseconds = now.getMilliseconds();
    
    const minutesUntilNextInterval = intervalInMinutes - (minutes % intervalInMinutes);
    const millisecondsUntilNextInterval = 
        minutesUntilNextInterval * 60 * 1000 - 
        seconds * 1000 - 
        milliseconds;
    
    // Configura un setTimeout para ejecutar la función en la próxima marca de intervalInMinutes
    setTimeout(() => {
        // Ejecuta la verificación del estado del servicio por primera vez
        store.dispatch('service-settings/fetchServiceStatus');
        
        // Luego, programa la función para que se ejecute cada intervalInMinutes minutos
        setInterval(() => {
            store.dispatch('service-settings/fetchServiceStatus');
        }, intervalInMinutes * 60 * 1000);
    }, millisecondsUntilNextInterval);
};

// Inicia la programación de la verificación cada intervalInMinutes minutos
scheduleNextExecution();

  // Revisa y muestra el modal cada minuto
  setInterval(checkAndRenderModal, 60000); // 1 minuto

  checkAndRenderModal()
}